/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/* 1.基本 */
export const template1 = {
  title: t.to('背景と物体', 'title1'),
  desc: t.to('このテンプレートを読み込むと赤い球体がVR空間の目の前に現れます。', 'desc1'),
  img: '../public/template/1.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
<variables>
</variables>
<block type="a-scene-start" x="170" y="70">
  <statement name="IN">
    <block type="sphere_v2" >
      <field name="id">block1</field>
      <field name="position-x">0</field>
      <field name="position-y">1</field>
      <field name="position-z">0</field>
      <value name="COLOUR">
        <shadow type="color_value_v2" >
          <field name="COLOUR">#ff0000</field>
        </shadow>
      </value>
      <next>
        <block type="environment_v2" >
          <field name="preset">forest</field>
        </block>
      </next>
    </block>
  </statement>
</block>
</xml>
`,
};
